export var MFSipRegistration = [
    { title: "All", value: "All" },
    { title: "Rejected", value: "Rejected" },
    { title: "Cancelled", value: "Cancelled" },
];
export var MFOrderBook = [
    { title: "All", value: "All" },
    { title: "Valid", value: "Valid" },
    { title: "Invalid", value: "Invalid" },
    { title: "Rejected", value: "Rejected" },
    { title: "Cancelled", value: "Cancelled" },
    { title: "NA", value: "NA" },
];
export var textConfig = {
    NoDataFound: "No Data Found",
};
